export default {
  data(){
    return {
      tag: '',
    }
  },
  methods: {
    async tagAutoCompleteOnFocus(){
      const r = await this.$store.dispatch("tag/search")
      console.log(r.data.tags)
      this.$store.commit("tag/setAutocompleteItems", r.data.tags)
    },
    async tagAutoComplete(e){
      this.$store.commit("tag/setName", e)
      const r = await this.$store.dispatch("tag/search")
      this.$store.commit("tag/setAutocompleteItems", r.data.tags)
    },
    tagChange(new_tags){
      console.log("new_tags", new_tags)
      this.$store.commit("tag/setItems", new_tags)
      console.log(new_tags)
    }
  },
  computed: {
    filteredItems() {
      var items = this.$store.state.tag.autocomplete_items.filter(i => {
        return i.name.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
      return items.map(item => {
        return { text: item.name }
      })
    },
  }
}
